import React, { CSSProperties, FC, PropsWithChildren, ReactNode } from "react";
import Text from "common/Typography/Text";
import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc";

interface HighlightedTextProps {
  style?: CSSProperties;
  color?: string;
  bgColor?: string;
  borderColor?: string;
  withBackgroundColor?: boolean;
  hideLine?: boolean;
  showBorder?: boolean;
  actionButton?: ReactNode;
}

const HighlightedText: FC<PropsWithChildren<HighlightedTextProps>> = ({
  children,
  style,
  color,
  withBackgroundColor = true,
  hideLine,
  showBorder,
  actionButton,
  bgColor,
  borderColor,
}) => {
  return (
    <Wrapper
      style={style}
      $color={color}
      $bgColor={bgColor}
      $withBackgroundColor={withBackgroundColor}
      $showBorder={showBorder}
    >
      <StyledText
        as="div"
        $color={color}
        $borderColor={borderColor}
        $hideLine={hideLine}
      >
        {" "}
        {children}
      </StyledText>
      {actionButton}
    </Wrapper>
  );
};

export default HighlightedText;

const Wrapper = styled.div<{
  $color?: string;
  $bgColor?: string;
  $withBackgroundColor?: boolean;
  $showBorder?: boolean;
}>`
  ${(p) =>
    p.$withBackgroundColor &&
    `
    background-color: ${
      p.$color ? hexToRGB(p.$color, 0.2) : p.theme.colors.highlightBgColor
    };
    border: ${p.theme.borders.medium};
    padding: 16px;
  `};
  ${(p) =>
    p.$showBorder
      ? `
     border: 1px solid ${p.$color || p.theme.colors.primaryBlue};
  `
      : "border: none;"};
  border-radius: 8px;
  ${(p) => p.$bgColor && `background-color: ${p.$bgColor};`};
`;
const StyledText = styled(Text)<{
  $color?: string;
  $borderColor?: string;
  $hideLine?: boolean;
}>`
  ${(p) =>
    !p.$hideLine &&
    `
    border-left: 3px solid ${
      p.$borderColor || p.$color || p.theme.colors.primaryBlue
    }; 
    padding-left: 16px;
  `};
  color: ${(p) => p.$color || p.theme.colors.primaryBlue};
  font-size: inherit;
`;
